import {Component, EventEmitter, NgZone, OnInit, Input, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Vehicle} from '../../models/vehicle';
import {VehiclesHandlerService} from '../../api-handlers/vehicles-handler.service';
import {Travel} from '../../models/travel';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';
import {SnackBarHandlerService} from '../../commons/snack-bar-handler.service';
import {Park} from '../../models/park';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ParksHandlerService} from '../../api-handlers/parks-handler.service';
import {AuthService} from '../../auth-n-routing/auth-service.service';

@Component({
	selector: 'app-assign-available-car-to-user',
	templateUrl: './assign-available-car-to-user.component.html',
	styleUrls: ['./assign-available-car-to-user.component.css']
})
export class AssignAvailableCarToUserComponent implements OnInit {
	modalRef: BsModalRef;
	vehicleToSet: Vehicle;
	@Input() travel: Travel;

	@ViewChild('template', { static: false }) template;
	@Output() vehicleSelected = new EventEmitter<Vehicle>();

	dom_elements = {
		assign_btn: {
			is_running: false,
			txt_run: 'VEICOLO SELEZIONATO ...',
			txt_not_run: 'SELEZIONA'
		}
	};

	park: Park;


	// Veicoli disponibili
	dataVehiclesIcons = [];
	vehicles_available = {};
	available_vehicles: any[] = [];
	returnedArray: any[];
	itemsPerPage = 25;
	maxSize = 5;
	date_vehicle_available_from: Date;
	date_vehicle_available_to: Date;


	constructor(
		public authService: AuthService,
		public vehiclesHandlerService: VehiclesHandlerService,
		public travelsHandlerService: TravelsHandlerService,
		public parksHandlerService: ParksHandlerService,
		public snackBarHandler: SnackBarHandlerService,
		private modalService: BsModalService,
		private ngZone: NgZone
	) { }

	ngOnInit() {
		this.dataVehiclesIcons = this.vehiclesHandlerService.dataVehiclesIcons;
	}

	getVehiclesFromPark(park: Park) {
		this.vehiclesHandlerService.getByParkIDInDataRangeAvailable(
			park.id,
			this.date_vehicle_available_from,
			this.date_vehicle_available_to).then((res) => {

				this.vehicles_available[park.id] = res;
				this.ngZone.run(() => {
					this.available_vehicles = this.vehicles_available[park.id];
					this.returnedArray = this.available_vehicles.slice(0, this.itemsPerPage);
					// this.loadstats = true;
					// this.updateCharts(park);
			});
		});
	}

	// Veicoli Disponibili*********************************************************

	getColorStatus(v) {

		if ( v.approved_travel_vehicle) {
			return 'btn-danger';
		} else if ( v.tech_shutdown_vehicle) {
			return 'btn-info';
		} else {
			return 'btn-success';
		}
	}

	getVehiclesTypeIcon(tipo) {
		let iconType;
		if (this.dataVehiclesIcons.find( x => x.type === tipo)) {
			iconType = this.dataVehiclesIcons.find( x => x.type === tipo).icon;
		} else {
			iconType = 'fa-car-side';
		}
		// console.log(iconType);
		// const iconType = 'fa-car-side';
		return iconType;
	}

	pageChanged(event: PageChangedEvent): void {
		const startItem = (event.page - 1) * event.itemsPerPage;
		const endItem = event.page * event.itemsPerPage;
		console.log(this.available_vehicles.length);
		console.log(this.available_vehicles);
		this.returnedArray = this.available_vehicles.slice(startItem, endItem);
	}

	assignVehicleAvailableInDateRange(v) {
		console.log(v);

		if (v.approved_travel_vehicle ) {
			this.snackBarHandler.showSnackbar('Veicolo impegnato in un viaggio', 3000);
		} else if (v.tech_shutdown_vehicle ) {
			this.snackBarHandler.showSnackbar('Veicolo fermo tecnico', 3000);
		} else {
			this.vehicleSelected.emit(v);
			this.modalRef.hide();
		}


	}

	showDialog() {
		// this.travelToApprove = travelToApprove;
		// this.vehicleToSet = new Vehicle(undefined);
		const travelID = this.travel.id.toString();
		this.date_vehicle_available_from = this.travel.required_from;
		this.date_vehicle_available_to = this.travel.required_to;
		this.parksHandlerService.getByTravelID(travelID).then((data: Park) => {
			this.park = data;
			this.getVehiclesFromPark(this.park);

			this.modalRef = this.modalService.show(this.template);
		});

	}
}
